<template>
  <div class="intro">
    <img src="static/apple-icon.png" alt="" class="logo" />
    <div>
      {{ $t("intro.welcomeToUnofficial") }}
      <b>{{ $t("intro.virtualTownSquare") }}</b>
      {{ $t("intro.forBloodOnClockTower") }}
      {{ $t("intro.pleaseAddPlayers") }}
      <span class="button" @click="toggleMenu">
        <font-awesome-icon icon="cog" /> {{ $t("menu.title") }}
      </span>
      {{ $t("intro.onTopRight") }} <b>[A]</b>{{ $t("intro.canAlsoJoin") }}
      <b>[J]</b>.<br />
      <div class="footer">
        {{ $t("intro.projectOpenSource") }}
        <a href="https://github.com/bra1n/townsquare" target="_blank">{{
          $t("intro.github")
        }}</a
        >{{ $t("intro.notAffiliated") }}
      </div>
    </div>
    <a
      class="redirect"
      v-if="language === 'zh-CN'"
      href="https://clocktower.gstonegames.com"
    >
      <img src="../assets/gstone.png" class="gstone" alt="" />
      {{ $t("intro.chineseVersionPrompt") }}
    </a>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      language: window.navigator.userLanguage || window.navigator.language,
    };
  },
  methods: mapMutations(["toggleMenu"]),
};
</script>

<style scoped lang="scss">
// Intro
.intro {
  text-align: center;
  width: 50%;
  font-size: 120%;
  position: absolute;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  border: 3px solid black;
  border-radius: 10px;
  z-index: 3;
  display: flex;
  justify-content: center;
  a {
    color: white;
  }
  a.redirect {
    display: block;
    text-decoration: none;
    position: absolute;
    top: 100%;
    margin-top: 2vh;
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: 3px solid black;
    border-radius: 10px;

    &:hover {
      color: red;
    }
    img {
      width: 120px;
      display: block;
      margin: auto;
      margin-bottom: 1vh;
    }
  }

  img.logo {
    position: absolute;
    bottom: 100%;
    width: 25vh;
    margin-bottom: 2vh;
    max-width: 192px;
    border-radius: 50%;
    box-shadow: 0 0 10px black;
    border: 3px solid black;
  }
  .footer {
    font-size: 60%;
    opacity: 0.75;
  }
}
</style>
